import React from "react";

export default function ButtonTitle(props: any){
    const renderSwitch = (param: any) => {
        if (props.buttonUrl === 'failedPayment') {
            return 'تلاش مجدد برای پرداخت';
        }
        switch(param) {
            case 'reTryWarning':
                return 'تلاش مجدد';
            case 'alert':
                return 'بازگشت';
            case 'maxTry':
                return 'متوجه شدم';
            case 'notCameraSupport':
                return 'متوجه شدم';
            case 'noFaceDetected':
                return 'تلاش مجدد';
            case 'severalFaces':
                return 'متوجه شدم';
            case 'farFace':
                return 'متوجه شدم';
            case 'complete':
                return 'پایان';
            case 'mismatch':
                return 'ورود دوباره';
            case 'editPersonalInfo':
                return 'ویرایش اطلاعات';
            default:
                return '';
        }
    }
    return (
        <>
            {renderSwitch(props.value)}
        </>
    )
}
